import getSlug from 'speakingurl'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.provide('getSlug', getSlug)
})